import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { catchError, filter, map, of, take } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthenticationService);
  const navCtrl = inject(NavController);
  const redirectToLogin = () => {
    void navCtrl.navigateRoot('/login', {
      animated: true,
      replaceUrl: true,
    });
    return false;
  };

  // During an OIDC login callback AppComponent sets this flag synchronously before Angular
  // routing starts. While it is set, wait for the async checkAuth to resolve instead of acting
  // on the initial (pre-auth) false emission — which would otherwise flash the /login page.
  const auth$ = authService.loginCallbackInProgress
    ? authService.isAuthenticated$().pipe(filter(Boolean), take(1))
    : authService.isAuthenticated$().pipe(take(1));

  return auth$.pipe(
    map(isAuthenticated => isAuthenticated || redirectToLogin()),
    catchError(() => of(redirectToLogin()))
  );
};
